import { render } from "./NewAddress.vue?vue&type=template&id=82ad2e60&scoped=true"
import script from "./NewAddress.vue?vue&type=script&lang=js"
export * from "./NewAddress.vue?vue&type=script&lang=js"

import "./NewAddress.vue?vue&type=style&index=0&id=82ad2e60&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82ad2e60"]])

export default __exports__